import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  getDalale,
  createDalale,
  updateDalale,
  deleteDalale
} from '../services/firestoreService';
import { generateDalalePDF } from '../services/pdfService';
import RecordAuditBlock from '../components/common/RecordAuditBlock';
import Button from '../components/common/Button';
import Input from '../components/common/Input';
import Loading from '../components/common/Loading';
import { downloadCsvFile, formatDate, toMoney } from '../utils/helpers';
import toast from 'react-hot-toast';

const DalaleDetail = () => {
  const { id } = useParams();
  const isNew = id === 'new';
  const navigate = useNavigate();
  const { user } = useAuth();
  const auditActor = user ? { uid: user.uid, email: user.email } : null;

  const [loading, setLoading] = useState(!isNew);
  const [submitting, setSubmitting] = useState(false);
  const [savedMeta, setSavedMeta] = useState(null);
  const [form, setForm] = useState({
    name: '',
    phone: '',
    degmo: '',
    commissionPercent: ''
  });

  useEffect(() => {
    if (isNew) return;
    (async () => {
      setLoading(true);
      const result = await getDalale(id);
      if (!result.success) {
        toast.error('Lama helin');
        navigate('/admin/dalale');
        return;
      }
      const d = result.data;
      setSavedMeta(d);
      setForm({
        name: d.name || '',
        phone: d.phone || '',
        degmo: d.degmo || '',
        commissionPercent: d.commissionPercent != null ? String(d.commissionPercent) : ''
      });
      setLoading(false);
    })();
  }, [id, isNew, navigate]);

  const handleSave = async () => {
    if (!form.name.trim() || !form.phone.trim()) {
      toast.error('Magaca iyo telefoon waa lagama maarmaan');
      return;
    }
    const commissionPercent = parseFloat(form.commissionPercent);
    if (form.commissionPercent === '' || !Number.isFinite(commissionPercent) || commissionPercent < 0) {
      toast.error('Commission % sax ah geli');
      return;
    }

    setSubmitting(true);
    const payload = {
      name: form.name.trim(),
      phone: form.phone.trim(),
      degmo: form.degmo.trim(),
      commissionPercent,
      auditActor
    };

    const result = isNew
      ? await createDalale(payload)
      : await updateDalale(id, payload);

    if (result.success) {
      toast.success('Waa la kaydiyay');
      if (isNew) navigate(`/admin/dalale/${result.id}`);
      else setSavedMeta((m) => (m ? { ...m, ...payload } : m));
    } else {
      toast.error(result.error);
    }
    setSubmitting(false);
  };

  const handleDelete = async () => {
    if (isNew || !window.confirm('Tirtir dalale-kan?')) return;
    const result = await deleteDalale(id);
    if (result.success) {
      toast.success('Waa la tirtiray');
      navigate('/admin/dalale');
    } else {
      toast.error(result.error);
    }
  };

  const handlePdf = async () => {
    const record = {
      ...form,
      commissionPercent: toMoney(form.commissionPercent),
      ...savedMeta,
      id: isNew ? undefined : id
    };
    await generateDalalePDF(record);
    toast.success('PDF waa la soo dejiyay');
  };

  const handleCsv = () => {
    const record = {
      ...form,
      commissionPercent: toMoney(form.commissionPercent),
      id: isNew ? '' : id,
      createdAt: savedMeta?.createdAt,
      updatedAt: savedMeta?.updatedAt
    };
    downloadCsvFile(
      `dalale-${(form.name || 'record').replace(/\s+/g, '-')}.csv`,
      ['ID', 'Magaca', 'Telefoon', 'Degmo', 'Commission (%)', 'La sameeyay', 'La cusbooneysiiyay'],
      [[
        record.id,
        record.name,
        record.phone,
        record.degmo,
        record.commissionPercent,
        formatDate(record.createdAt),
        formatDate(record.updatedAt)
      ]]
    );
    toast.success('CSV waa la soo dejiyay');
  };

  if (loading) return <Loading fullScreen />;

  return (
    <div className="space-y-6 max-w-2xl mx-auto">
      <div className="flex flex-wrap gap-2 justify-between items-center">
        <Button variant="ghost" onClick={() => navigate('/admin/dalale')}>← Liiska dalale</Button>
        <div className="flex flex-wrap gap-2">
          <Button variant="outline" onClick={handleCsv}>CSV</Button>
          <Button variant="outline" onClick={handlePdf}>PDF</Button>
          <Button onClick={handleSave} loading={submitting}>Kaydi</Button>
          {!isNew && <Button variant="danger" onClick={handleDelete}>Tirtir</Button>}
        </div>
      </div>

      <div className="bg-white rounded-xl border p-4 space-y-4">
        <Input
          label="Magaca dalale"
          value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
          placeholder="Magaca buuxa"
          required
        />
        <Input
          label="Telefoon"
          type="tel"
          value={form.phone}
          onChange={(e) => setForm({ ...form, phone: e.target.value })}
          placeholder="061XXXXXXX"
          required
        />
        <Input
          label="Degmada uu joogo"
          value={form.degmo}
          onChange={(e) => setForm({ ...form, degmo: e.target.value })}
          placeholder="Tusaale: Hodan, Wadajir..."
        />
        <Input
          label="Commission (%)"
          type="number"
          min="0"
          max="100"
          step="0.01"
          value={form.commissionPercent}
          onChange={(e) => setForm({ ...form, commissionPercent: e.target.value })}
          placeholder="5"
          required
        />
      </div>

      {!isNew && savedMeta && (
        <div className="bg-slate-50 rounded-xl border p-4">
          <RecordAuditBlock record={savedMeta} />
        </div>
      )}
    </div>
  );
};

export default DalaleDetail;
